module.exports = __webpack_public_path__ + "static/media/head-road-home.d87f05ac.png";